export const version = '0.807.4'
export const chameleonWebVersion = '10.5.1'
export const chameleonCoreVersion = '7.14.0'
